import { useSelector } from "react-redux";
import MPink from "../assets/img/MPink.png";

const RestaurantLoader = ({ message = "Loading" }) => {
  const color = useSelector((state) => state.global.color);
  const { darkMode } = useSelector((state) => state.global);

  return (
    <div className="section-loader-container">
      <div className="animated-loader-box">
        <div className="loader-ring-wrapper">
          <img src={MPink} alt="Loader Icon" className="center-loader-img" />
          <div
            className="spinning-ring"
            style={{ borderTopColor: color }}
          ></div>
        </div>
        <div
          className={`animated-loader-text ${
            darkMode ? "text-light" : "text-dark"
          }`}
        >
          {message}
          <span className="dot">.</span>
          <span className="dot">.</span>
          <span className="dot">.</span>
        </div>
      </div>
    </div>
  );
};

export default RestaurantLoader;
